import React, {useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

import LookAiPopupContext from "./LookAiPopupContext";
import {postGenerateLookAiImage} from "../../aiApi/aiApi";
import {MaterialResetImageIcon} from "../../../common/svgIcons/materialIcons";
import {IS_QKB_UI} from "../../../../config";
import {imageIsRenderedAndUserIsNotLoggedIn} from "../../aiFunctions";
import {getSignal, newController} from "../../aiApi/aiController";
import {isAiRenderLimitReached} from "../../aiConfig";
import {setLookAiLimitBoxOpened} from "../../aiActions";


const LookAIPopupGenerateButton = (props) => {

  const {postGenerateLookAiImage, setLookAiLimitBoxOpened, aiResults, aiLoading, showLeadOverlay} = props;

  const {lookAiPopupContext} = useContext(LookAiPopupContext);

  const someResultExist = aiResults.some(res => res.resultImageUrl);
  const disabled = aiLoading
    || !lookAiPopupContext.userFile
    || !lookAiPopupContext.groupObjects
    || !lookAiPopupContext.groupObjects.some(groupObject => groupObject.enabled)
    || imageIsRenderedAndUserIsNotLoggedIn(showLeadOverlay, aiResults);

  const onGenerateClick = () => {
    if (disabled) {
      return
    }
    if (isAiRenderLimitReached(aiResults)) {
      setLookAiLimitBoxOpened(true);
      return
    }
    const controller = newController(); // replace the shared controller
    postGenerateLookAiImage(lookAiPopupContext, controller.signal ?? getSignal())
  }

  return (
    <div className="u-p-1 bg-white look-ai__content u-w-full">
      <p className="font--11 u-leading-075">
        <FormattedMessage id="look.ai.panel.generateButtonText"/>
      </p>
      <Button className={"u-rounded-025 nowrap u-p-0 u-w-full"
        + (IS_QKB_UI ? " ui-button2 ui-button2--green ui-button2--white2 u-h-25" : " look-button look-button--primary")}
              style={{fontSize: "12px"}}
              disabled={disabled}
              startIcon={someResultExist ? MaterialResetImageIcon : <ImageOutlinedIcon/>}
              onClick={onGenerateClick}>
        <FormattedMessage id={someResultExist ? "look.ai.panel.reGenerateButton" : "look.ai.panel.generateButton"}/>
      </Button>
    </div>
  )
};

LookAIPopupGenerateButton.propTypes = {
  showLeadOverlay: PropTypes.bool.isRequired,
}

const mapStateToProps = (store) => {
  const {aiResults, aiLoading} = store.aiState;

  return {
    aiResults,
    aiLoading,
  };
};

const mapDispatchToProps = {
  postGenerateLookAiImage,
  setLookAiLimitBoxOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookAIPopupGenerateButton)
